
import React from 'react';
import { motion } from 'framer-motion';
import { Layers } from 'lucide-react';
import { TECH_STACK } from '../constants';

const TechStack: React.FC<{ darkMode: boolean }> = ({ darkMode }) => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: { y: 0, opacity: 1 }
  };

  return (
    <div className="py-10">
      <div className="flex items-center gap-3 mb-12">
        <Layers className="text-blue-600" size={32} />
        <h3 className="text-3xl font-bold">Tech Stack</h3>
      </div>

      <motion.div 
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
      >
        {TECH_STACK.map((category, idx) => (
          <motion.div 
            key={idx} 
            variants={itemVariants}
            whileHover={{ y: -5 }}
            className={`group p-8 bg-white ${darkMode ? 'dark:bg-slate-900/40 backdrop-blur-sm' : ''} rounded-3xl border border-slate-200 dark:border-slate-800 hover:border-blue-500/50 transition-all duration-300 shadow-sm hover:shadow-2xl`}
          >
            <h4 className={`text-lg font-bold mb-6 text-slate-900 ${darkMode ? 'dark:text-white' : ''} border-b border-slate-100 dark:border-slate-800 pb-4 flex items-center justify-between`}>
              {category.title}
              <span className={`text-xs bg-blue-100 ${darkMode ? 'dark:bg-blue-900/30 text-blue-600 dark:text-blue-400' : 'text-blue-600'} px-2 py-1 rounded-lg`}>
                {category.skills.length} skills
              </span>
            </h4>
            <div className="flex flex-wrap gap-2">
              {category.skills.map((skill, sIdx) => (
                <motion.span 
                  key={sIdx} 
                  whileHover={{ scale: 1.1, backgroundColor: '#2563eb', color: '#ffffff' }}
                  className={`px-3 py-1.5 ${darkMode ? 'bg-slate-100 dark:bg-slate-800 dark:text-slate-300 text-slate-700' : 'bg-slate-100 text-slate-700'} rounded-xl text-sm font-medium transition-all cursor-default`}
                >
                  {skill}
                </motion.span>
              ))}
            </div>
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
};

export default TechStack;
